// Pure helpers for the Credits page (no DOM): unit-tested in credits.test.ts.

/** "1,250 credits": a pack named only by its size, which the page already shows in big type. The named tiers
 *  ("Creator", "Pro") are real names and are shown. */
export const isCountName = (name: string): boolean => /^\s*[\d,.]+\s*credits?\s*$/i.test(name);
